import { SvgIcon, SvgIconProps } from '@mui/material';

export const ArrowDownwardCircle = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
        <circle cx="15.1673" cy="15.1667" r="14.1667" transform="rotate(-180 15.1673 15.1667)" stroke="white" strokeWidth="2" />
        <path d="M15.334 9.33334L15.334 21.3333M15.334 21.3333L10.334 16.1905M15.334 21.3333L20.334 16.1905" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </SvgIcon>
  );
};
